import get from "lodash.get";
import styled from "styled-components";
import PhoneInput from "react-phone-number-input";
import Input from "react-phone-number-input/input";

export const FormLeft = styled.div`
  /* width: 60%; */
  /* background: linear-gradient(45deg, #1847ff 0%, #428ef9 100%); */
`;

export const FormRight = styled.div`
  width: 100%;
  /* background-color: ${({ theme }) => get(theme, "background.main")}; */
  background: linear-gradient(80.18deg, rgba(48, 46, 145, 0.3) 0%, rgba(57, 118, 174, 0.3) 100%);
  .main-form,
  .sign-in-form {
    position: relative;
    top: 50%;
    transform: translateY(-75%);
    max-width: 480px;
    margin: 0 auto;
    background: ${({ theme }) => get(theme, "background.main")};
    /* box-shadow: 0px 0px 10px ${({ theme }) => get(theme, "background.hoverPrimary")}; */
    border-radius: 9px;
    padding: 50px;
  }
  .PhoneInputInput {
    background-color: ${({ theme }) => get(theme, "background.main")} !important;
  }

  .edit-password {
    background: transparent;
    border: none;
    outline: none;
  }
  .sign-in-div {
    position: relative;
    .sig-in-btn {
      position: absolute;
      z-index: 1000;
      right: 10px;
      top: 0;
      bottom: 0;
      &:hover {
        background-color: transparent;
        color: initial;
        cursor: initial;
      }
    }
  }
`;

export const PasswordStyle = styled.input<any>`
  color: ${({ theme }) => get(theme, "black.dark")} !important;
  padding: 13px 16px !important;
  background-color: ${({ theme }) => theme.background.primary};
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 15px !important;
  line-height: 20px !important;
  letter-spacing: -0.02em !important;
  outline: none !important;
  box-shadow: none !important;
  border-radius: 12px;
  border: none;

  &::placeholder {
    color: ${({ theme }) => get(theme, "black.dark")};
  }
  &::-webkit-inner-spin-button,
  &::-webkit-calendar-picker-indicator {
    display: none;
  }
  &:focus {
    background-color: ${({ theme }) => theme.background.hoverPrimary};
  }
`;

export const InputContent = styled("div")`
  position: relative;
  .eye-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    .hover-style {
      cursor: pointer;
      width: 33px;
      height: 33px;
    }
  }
`;

export const NumberInputStyled = styled(Input)`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.form.light} !important;
  box-sizing: border-box;
  width: ${(props: any) => (props.type === "checkbox" ? "auto" : "100%")};
  color: ${({ theme }) => theme.secondary.dark} !important;
  padding: 13px 16px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.02em;
  outline: none;
  transition: all 0.2s linear !important;
  background-color: ${({ theme }) => theme.background.primary};
  &::-webkit-inner-spin-button,
  &::-webkit-calendar-picker-indicator {
    display: ${(props) =>
      props.type === "number" || props.type === "time" ? "none" : "block"};
    position: absolute;
    width: 17px;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    height: 17px;
    background-repeat: no-repeat;
  }
  &:focus {
    box-shadow: none;
    color: ${({ theme }) => theme.secondary.medium};
    border-color: ${({ theme }) => theme.white.light};
    background-color: ${({ theme }) => theme.background.hoverPrimary};
    
  }
  &::placeholder {
    color: ${({ theme }) => theme.secondary.main};
  }
`;

export const PhoneNumberStyled: any = styled(PhoneInput)`
  .PhoneInputInput {
    border-radius: 8px;
    border: 1px solid
      ${({ theme, isError }) => (isError ? theme.error.main : theme.form.light)} !important;
    box-sizing: border-box;
    width: ${(props: any) => (props.type === "checkbox" ? "auto" : "100%")};
    color: ${({ theme }) => theme.secondary.dark} !important;
    padding: 13px 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    outline: none;
    transition: all 0.2s linear !important;
    background-color: ${({ theme, isError }) =>
      isError ? theme.transparent : theme.form.light};

    &::-webkit-inner-spin-button,
    &::-webkit-calendar-picker-indicator {
      display: ${(props) =>
        props.type === "number" || props.type === "time" ? "none" : "block"};
      position: absolute;
      width: 17px;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      height: 17px;
      background-repeat: no-repeat;
    }
    &:focus {
      box-shadow: none;
      color: ${({ theme }) => theme.secondary.medium};
      border-color: ${({ theme }) => theme.white.light};
      background-color: ${({ theme, isError }) =>
        isError ? theme.transparent : theme.form.main};
    }
    &::placeholder {
      color: ${({ theme }) => theme.secondary.dark};
    }
  }
  .PhoneInputCountry {
    .PhoneInputCountrySelect {
      option {
        padding: 0.75rem 2rem 0.75rem 1rem !important;
        color: ${({ theme }) => get(theme, "secondary.dark")} !important;
        font-size: 14px;
        transition: color 0.2s ease;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      option:hover {
        background: ${({ theme }) => get(theme, "secondary.light")}!important;
        color: ${({ theme }) => get(theme, "primary.main")} !important;
      }
      option.active {
        background: ${({ theme }) => get(theme, "secondary.light")} !important;
        color: ${({ theme }) => get(theme, "primary.main")} !important;
      }
    }
  }
`;
